import { c as _c } from "react/compiler-runtime";
import { Field as ChakraField } from '@chakra-ui/react';
import { forwardRef } from 'react';
export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
}
export const Field = forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const $ = _c(21);
  let children;
  let errorText;
  let helperText;
  let label;
  let optionalText;
  let rest;
  if ($[0] !== props) {
    ({
      label,
      children,
      helperText,
      errorText,
      optionalText,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = errorText;
    $[3] = helperText;
    $[4] = label;
    $[5] = optionalText;
    $[6] = rest;
  } else {
    children = $[1];
    errorText = $[2];
    helperText = $[3];
    label = $[4];
    optionalText = $[5];
    rest = $[6];
  }
  let t0;
  if ($[7] !== label || $[8] !== optionalText) {
    t0 = label && <ChakraField.Label>{label}<ChakraField.RequiredIndicator fallback={optionalText} /></ChakraField.Label>;
    $[7] = label;
    $[8] = optionalText;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  let t1;
  if ($[10] !== helperText) {
    t1 = helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>;
    $[10] = helperText;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== errorText) {
    t2 = errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>;
    $[12] = errorText;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== children || $[15] !== ref || $[16] !== rest || $[17] !== t0 || $[18] !== t1 || $[19] !== t2) {
    t3 = <ChakraField.Root ref={ref} {...rest}>{t0}{children}{t1}{t2}</ChakraField.Root>;
    $[14] = children;
    $[15] = ref;
    $[16] = rest;
    $[17] = t0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
});